module.exports = __webpack_public_path__ + "img/Delete-Ad.27e4e0f6.svg";